var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-static" },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c("main", [
        _vm.showInfoArea
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "info-area" }, [_vm._t("info-area")], 2)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "container" }, [_vm._t("default")], 2)
      ]),
      _vm._v(" "),
      _c(
        "footer",
        [
          _vm._t("footer", function() {
            return [_c("Footer")]
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2db7c250", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db7c250","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/StaticLayout.vue
// module id = null
// module chunks = 